import "./DayChips.css";

/* 요일 고르개 = claude.ai 설정 창 "방해 금지 시간"의 요일 칩 실측
   (2026-10-19, docs/rail-reference.json settingsDialog.dayChips).
   32 원 · 12/17 580 · 꺼짐 회색 10%/#898781 · 켜짐 검정/흰 글자 · 사이 12.
   드롭다운(MultiPicker)을 쓰던 자리다 — 일곱 개뿐이라 펼쳐 두는 쪽이 한 번에 읽히고,
   무엇이 켜졌는지 열어 보지 않아도 안다. */
export const WEEK_DAYS = ["일", "월", "화", "수", "목", "금", "토"] as const;

export function DayChips({ value, onChange, disabled, invalid, ariaLabel = "근무 요일" }: {
  value: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean; invalid?: boolean; ariaLabel?: string;
}) {
  return <div className={`day-chips${invalid ? " is-invalid" : ""}`} role="group" aria-label={ariaLabel}>
    {WEEK_DAYS.map(day => {
      const on = value.includes(day);
      return <button key={day} type="button" className="day-chip" aria-pressed={on} disabled={disabled}
        onClick={() => onChange(WEEK_DAYS.filter(item => item === day ? !on : value.includes(item)))}>
        {day}
      </button>;
    })}
  </div>;
}
